export default function (...args)
{
	return {

		events: ['change'],

		getValue(default_value = document.querySelector(this.selector + ' [checked]')?.value, _this = this)
		{
			return this.safeProtoCall(default_value, _this);
		},

		refresh()
		{
			let selected = this.getValue();
			let nodes = document.querySelectorAll(this.selector);
			nodes.forEach(node =>
			{
				node.checked = (node.value == selected);
			});
		},

		handleEvents(ev)
		{
			this.setValue(ev.target.value);
			this.refresh();
		}

	};
}

